module.exports = __webpack_public_path__ + "fonts/TTNormsPro-LightItalic.fb4fa1cf.woff";